module.exports = __webpack_public_path__ + "static/media/ajuma_logo2.eb65c339.png";